export default __webpack_public_path__ + "static/media/water-lower.edcb5eb5.jpg";